import { AuthStore } from "../../stores/auth";
import { store } from "../../stores/store";
import { WhiteLabelColors } from "../volateq-api/api-schemas/customer-schemas";
import { volateqApi } from "../volateq-api/volateq-api";

class WhiteLabelingService {
  async getLogoUrl(): Promise<string> {
    if (store.auth.whiteLabelingVersion) {
      return URL.createObjectURL(await volateqApi.getCustomerLogoImg(store.auth.whiteLabelingVersion));
    }

    return "/images/logos/logo_default.png";
  }

  async appendStyles() {
    if (!store.auth.whiteLabelingVersion) {
      return;
    }

    const whiteLabelColors = await volateqApi.getCustomerWhiteLabelColors(store.auth.whiteLabelingVersion);
    if (!whiteLabelColors) {
      return;
    }

    const cssVars = this.createCSSVariables(whiteLabelColors);
    for (const cssVar of Object.keys(cssVars)) {
      document.documentElement.style.setProperty(cssVar, cssVars[cssVar]);
    }
  }

  private createCSSVariables(whiteLabelColors: WhiteLabelColors): Record<string, string> {
    return {
      "--primary-bg-color": whiteLabelColors.primary,
      "--primary-bg-highlight-color": whiteLabelColors.primary_hover,
      "--primary-bg-highlight-deep-color": whiteLabelColors.primary_dark,
      "--primary-border-color": whiteLabelColors.primary_border,
      "--secondary-text-color": whiteLabelColors.primary,
      "--secondary-border-color": whiteLabelColors.primary,
      "--secondary-bg-highlight-color": whiteLabelColors.secondary_hover,
    };
  }
}

export const whiteLabelingService = new WhiteLabelingService();